import { useEffect } from 'react'
import { isIgnoredElementOrChild } from './useOnClickOutside'

export const useOnClickInside = (
  containerId: string,
  handler: (event: Event) => void,
  ignoredClassNames?: Array<string>
): void => {
  const container = containerId ? document.getElementById(containerId) : null

  useEffect(() => {
    if (!container) return

    const listener = (event: Event) => {
      // Check if click is on ignored elements
      if (
        ignoredClassNames &&
        event.target instanceof Element &&
        isIgnoredElementOrChild(event.target, ignoredClassNames)
      ) {
        return
      }

      handler(event)
    }

    container.addEventListener('mousedown', listener)
    container.addEventListener('touchstart', listener)

    return () => {
      container.removeEventListener('mousedown', listener)
      container.removeEventListener('touchstart', listener)
    }
    // TODO: @gev-davtyan-rf remove this comment if container was not passed as a dependency for a reason
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handler, ignoredClassNames])
}
